import React, { FC } from 'react';
import { FormInputSwitch } from '../../../inputs/FormInputSwitch';

interface switchSettingProps {
  title: string;
  label?: string;
  value?: string;
  isDisabled?: boolean;
  switchName: string;
  handleChange: (isChecked: boolean) => void;
}

const defaultProps = {
  label: '',
  value: '',
  isDisabled: false,
};

export const SwitchSetting: FC<switchSettingProps> = ({
  title,
  value,
  label,
  isDisabled,
  switchName,
  handleChange,
}) => {
  return (
    <div className={isDisabled ? 'switch-setting switch-setting_disabled' : 'switch-setting'}>
      <div className="switch-setting__header">
        <article className="switch-setting__header__title">{title}</article>
        <FormInputSwitch name={switchName} isDisabled={isDisabled} handleChange={handleChange} />
      </div>
      {label || value ? (
        <div className="switch-setting__info">
          {!!label && (
            <p className={isDisabled ? 'switch-setting__info__label_disabled' : 'switch-setting__info__label'}>
              {label}
            </p>
          )}
          {!!value && <p className="switch-setting__info__value">{value}</p>}
        </div>
      ) : null}
    </div>
  );
};

SwitchSetting.defaultProps = defaultProps;
